// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatNewProjectForm-moduleactions__pNXNY";
var _2 = "GretaAIChatNewProjectForm-moduledescription___mCft";
var _3 = "GretaAIChatNewProjectForm-moduleform__T1DDJ";
var _4 = "GretaAIChatNewProjectForm-moduleheader__fS1nD";
var _5 = "GretaAIChatNewProjectForm-moduletitle__g7y6l";
export { _1 as "actions", _2 as "description", _3 as "form", _4 as "header", _5 as "title" }
